const breakingNewsBannerFieldsSelector = [
  'fields.tagline',
  'fields.title',
  'fields.type',
  'fields.story',
  'sys.id'
].join(',')

export default breakingNewsBannerFieldsSelector
